<button class="time-slot block-variant" [ngClass]="{ active: active }">
  @if (timeSlot.title) {
    <div class="title">{{ timeSlot.title }}</div>
    <div class="interval">
      {{ timeSlot.interval }}
    </div>
  } @else {
    <div class="interval">
      {{ timeSlot.interval }}
    </div>
    <div class="price">{{ timeSlot.price }} ₽</div>
  }
</button>
